import React from "react";
import { Link } from "react-router-dom";

const ErrorFallback = ({ error, resetErrorBoundary, errorType = "general" }) => {
  const getErrorContent = () => {
    switch (errorType) {
      case "404":
        return {
          title: "404 - Page Not Found",
          message: "The page you're looking for doesn't exist or has been moved.",
          suggestion: "Please check the URL or return to the homepage.",
        };
      case "403":
        return {
          title: "403 - Access Denied",
          message: "You don't have permission to access this resource.",
          suggestion: "Please contact your administrator if you believe this is an error.",
        };
      case "500":
        return {
          title: "500 - Server Error",
          message: "Something went wrong on our end.",
          suggestion: "Please try again later or contact support if the problem persists.",
        };
      default:
        return {
          title: "Oops! Something went wrong",
          message: error?.message || "An unexpected error occurred.",
          suggestion: "Please try refreshing the page or contact support if the issue continues.",
        };
    }
  };

  const content = getErrorContent();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            {content.title}
          </h2>
          <p className="mt-2 text-sm text-gray-600">{content.message}</p>
          <p className="mt-2 text-sm text-gray-500">{content.suggestion}</p>

          {error?.stack && (
            <details className="mt-4 text-left">
              <summary className="cursor-pointer text-sm text-gray-700 hover:text-gray-900">
                Error Details
              </summary>
              <pre className="mt-2 text-xs bg-gray-100 p-4 rounded overflow-auto max-h-64">
                {error.stack}
              </pre>
            </details>
          )}

          <div className="mt-6 space-y-3">
            {resetErrorBoundary && (
              <button
                onClick={resetErrorBoundary}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Try Again
              </button>
            )}
            <Link
              to="/"
              className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Go to Homepage
            </Link>
            <button
              onClick={() => window.location.reload()}
              className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Refresh Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
